<template>
<!-- 产能报表 -->
  <div class="rzy-page">
    <el-date-picker v-model="selectMonth" type="month" placeholder="选择月" @change="changeMonth"/>
    <el-button type="success" @click="initExcel('capacityTable')">导出Excel</el-button>
    <el-table :data="capacityCountList" :header-cell-style="{'text-align':'center'}" id="capacityTable"
        :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600">
        <el-table-column v-for="(obj,key,index) in sumLeftKeys" :key="index" fixed="left"
          :label="obj.value" :prop="key" :width="obj.width"/>
        <el-table-column :label="`${index+1}号(米)`" v-for="(item,index) in lastDate" :key="item" width="80">
            <template slot-scope="data">
                {{data.row.dailyData[index].capacity}}
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'machineCapacity',
  data() {
    return {
        sumLeftKeys: {
              title: { value: '机台', width: '120' },
              sumCapacity: { value: '产能合计(米)', width: '120' },
              meanCapacity: { value: '产能平均(米)', width: '120' }
        },
        capacityCountList: [],
        selectMonth: '',
        lastDate: 0
    }
  },
  methods: {
    // 获取当前月份的报表数据
    getNowCount() {
      const now = new Date().getTime()
      this.selectMonth = now
      this.getCapacityCount(this.utils.getFirstTimeByMonth(now), this.utils.getLastTimeByMonth(now))
    },
    // 获取开始到结束时间的报表数据
    getCapacityCount(startTime, endTime) {
      return this.$requestBase({
        url: 'v1/factory/machine/count/daily',
        method: 'get',
        params: {
          startTime,
          endTime
        }
      }).then((res) => {
        if (this.utils.isNowMonth(startTime)) {
          this.lastDate = new Date().getDate()
        } else {
          this.lastDate = new Date(endTime).getDate()
        }
        this.formatCapacityCount(res.data)
      })
    },
    // 格式化报表数据
    formatCapacityCount(response) {
      var groupByMachineId = this._.groupBy(response.dailyDataList, (item) => {
        return item.machineId
      })
      // 补全机台，可能有机台一条数据都没有
      var formatArr = this.completionMachine(response.machineList, groupByMachineId)
      const date = this.lastDate
      var arrCapacity = this._.range(0, date, 0)
      var arrCapacityLive = 0
      for (var machineId in groupByMachineId) {
        var machineData = groupByMachineId[machineId]
        var dailyData = this._.range(date)
        var itemCapacitySum = 0
        var itemCapacityLive = 0
        machineData.forEach((item) => {
          const index = new Date(item.whichDay).getDate() - 1
          var capacity = item.productMeter / 100
          if (capacity > 0) {
            arrCapacity[index] += capacity
            arrCapacityLive += 1
            itemCapacitySum += capacity
            itemCapacityLive += 1
            capacity = capacity.toFixed(2)
          } else {
            capacity = this.$params.countEmpty
          }
          dailyData[index] = {
            runningTime: item.runningTime,
            date: index + 1,
            capacity
          }
        })
        // 补齐没有产能的天数
        dailyData = this.completionDailyData(dailyData)
        var formatObj = {
          title: `${machineData[0].machineNum}(${machineData[0].machineWorkShop})`,
          machineId: machineData[0].machineId,
          machineNum: machineData[0].machineNum,
          machineWorkShop: machineData[0].machineWorkShop,
          meanCapacity: itemCapacityLive > 0 ? `${(itemCapacitySum / itemCapacityLive).toFixed(2)}` : '0.00',
          sumCapacity: `${itemCapacitySum.toFixed(2)}`,
          dailyData: dailyData
        }
        formatArr.push(formatObj)
      }
      formatArr = this._.sortBy(formatArr, (obj) => {
        // 默认升序 降序return的结果加 - ，-obj.machine.number
        // 提取字母 obj.machineNumber.replace(/[^a-z]+/ig,"");
        var machineNumber = obj.machineNum.replace(/[^0-9]+/gi, '')
        return Number(machineNumber)
      })
      const sumCount = this.formatSumCount({
        arrCapacity,
        arrCapacityLive
      })
      this.capacityCountList = sumCount.concat(formatArr)
    },
    // 补全机台
    completionMachine(capacityList, groupByMachineId) {
        const formatArr = []
        capacityList.forEach((item) => {
          if (!this._.has(groupByMachineId, item.machineId)) {
                let dailyData = this._.range(this.lastDate)
                dailyData = this.completionDailyData(dailyData)
                formatArr.push({
                  title: `${item.machineNum}(${item.machineWorkShop})`,
                  machineId: item.machineId,
                  machineNum: item.machineNum,
                  machineWorkShop: item.machineWorkShop,
                  meanCapacity: '0.00',
                  sumCapacity: '0.00',
                  dailyData
                })
            }
        })
        return formatArr
    },
    // 补齐没有产能的天数
    completionDailyData(dailyData) {
      dailyData.forEach((item, index) => {
        if (!this._.isObject(item)) {
          dailyData[index] = {
            runningTime: 0,
            date: index + 1,
            capacity: this.$params.countEmpty
          }
        }
      })
      return dailyData
    },
    // 汇总的逻辑单独抽出
    formatSumCount(arrObj) {
      var sumDailyData = this._.range(this.lastDate)
      var arrCapacity = arrObj.arrCapacity
      // var arrCapacityLive = arrObj.arrCapacityLive
      var arrCapacitySum = 0
      var arrCapacityDay = 0
      sumDailyData.forEach((item, index) => {
        var capacity = arrCapacity[index]
        if (capacity > 0) {
          arrCapacitySum += capacity
          // eslint-disable-next-line no-unused-vars
          arrCapacityDay += 1
          capacity = capacity.toFixed(2)
        } else {
          capacity = this.$params.countEmpty
        }
        sumDailyData[index] = {
          date: index + 1,
          capacity
        }
      })
      var formatSum = [
        {
          title: '汇总',
          sumCapacity: `${arrCapacitySum.toFixed(2)}`,
          meanCapacity: arrCapacityDay > 0 ? `${(arrCapacitySum / arrCapacityDay).toFixed(2)}` : '0.00',
          dailyData: sumDailyData
        }
      ]
      return formatSum
    },
    changeMonth(val) {
        const selectTime = val.getTime()
        this.getCapacityCount(this.utils.getFirstTimeByMonth(selectTime), this.utils.getLastTimeByMonth(selectTime))
    },
    initExcel(id) {
      const select = new Date(this.selectMonth)
      const year = select.getFullYear()
      const month = select.getMonth() + 1
      this.utils.exportExcel(id, `${year}年${month}月机台产能报表`)
    }
  },
  created() {
      this.getNowCount()
  },
  watch: {}
}
</script>

<style lang="scss"></style>
